export default __webpack_public_path__ + "static/media/Potion of Wisdom (4h).a38b5c44.jpg";